/**
 * French translations for Onboarding System
 * User onboarding checklist and progress tracking
 */

export const onboarding = {
  // Checklist UI
  'onboarding.checklist.title': 'Checklist d\'intégration',
  'onboarding.checklist.description': 'Complétez ces étapes pour profiter pleinement de subvention360',
  'onboarding.checklist.progress': '{completed} sur {total} complété',
  'onboarding.checklist.completed': 'Félicitations ! Vous avez terminé l\'intégration',

  // Steps
  'onboarding.steps.create_profile': 'Créer votre premier profil',
  'onboarding.steps.add_company_data': 'Ajouter les informations de votre entreprise',
  'onboarding.steps.explore_subsidies': 'Explorer les subventions disponibles',
  'onboarding.steps.save_favorite': 'Sauvegarder votre première subvention favorite',
  'onboarding.steps.setup_calendar': 'Configurer les rappels de calendrier',

  // Actions
  'onboarding.action.start': 'Commencer',
  'onboarding.action.continue': 'Continuer',
  'onboarding.action.skip': 'Passer',
  'onboarding.action.complete': 'Terminer',

  // Messages
  'onboarding.welcome.title': 'Bienvenue sur subvention360 !',
  'onboarding.welcome.subtitle': 'Commençons votre parcours vers les subventions',
  'onboarding.completion.title': 'Bravo !',
  'onboarding.completion.message': 'Vous êtes maintenant prêt à trouver les meilleures subventions pour votre entreprise',

  // Role Selection
  'onboarding.role_selection.roles.consultant.title': 'Consultant',
  'onboarding.role_selection.roles.business_owner.title': 'Chef d\'Entreprise',
  'onboarding.role_selection.roles.team_member.title': 'Membre d\'Équipe',

  // Wizard Welcome Messages (Success Toast after onboarding completion)
  'onboarding.wizard.welcome.consultant': 'Votre compte consultant est prêt ! Vous pouvez maintenant gérer plusieurs clients et trouver des subventions pour eux.',
  'onboarding.wizard.welcome.business_owner': 'Votre compte est configuré ! Découvrez les subventions adaptées à votre entreprise.',
  'onboarding.wizard.welcome.team_member': 'Bienvenue dans l\'équipe ! Vous pouvez maintenant collaborer sur les subventions.',

  // Wizard Step Titles & Descriptions
  'onboarding.wizard.step1.title': 'Détails de votre entreprise',
  'onboarding.wizard.step1.subtitle': 'Parlez-nous de votre entreprise',
  'onboarding.wizard.step1.subtitle.simple': 'Informations essentielles',
  'onboarding.wizard.step1.subtitle.long': 'Ces informations nous aident à trouver les opportunités de financement les plus pertinentes',
  'onboarding.wizard.step2.title': 'Confidentialité & Préférences',
  'onboarding.wizard.step2.subtitle': 'Paramètres de confidentialité',
  'onboarding.wizard.step3.title': 'Moyen de paiement',
  'onboarding.wizard.step3.subtitle': 'Aucun paiement aujourd\'hui',

  // Full Name Field
  'onboarding.wizard.fullName': 'Nom complet',
  'onboarding.wizard.fullName.placeholder': 'Votre nom et prénom',

  // Business Details Form
  'onboarding.business.companyName': 'Nom de l\'entreprise',
  'onboarding.business.companyName.placeholder': 'Entrez le nom de votre entreprise',
  'onboarding.business.siret': 'Numéro SIRET',
  'onboarding.business.siret.placeholder': 'SIRET à 14 chiffres (ex: 53801120600017)',
  'onboarding.business.siret.label': 'Numéro SIRET',
  'onboarding.business.siret.helper': 'Identifiant français de l\'entreprise',
  'onboarding.business.siret.readonly': 'Auto-rempli depuis la recherche ci-dessus, ou saisie manuelle',
  'onboarding.business.siret.warning': '⚠️ Requis pour l\'enrichissement automatique des données de l\'entreprise et un matching précis des subventions',
  'onboarding.business.industry': 'Secteur d\'activité',
  'onboarding.business.industry.placeholder': 'Sélectionnez votre secteur',
  'onboarding.business.companySize': 'Taille de l\'entreprise',
  'onboarding.business.companySize.placeholder': 'Sélectionnez la taille de l\'entreprise',
  'onboarding.business.location': 'Siège social',
  'onboarding.business.location.placeholder': 'Ville, Pays',
  'onboarding.business.operatingRegions': 'Régions d\'activité',
  'onboarding.business.operatingRegions.placeholder': 'Où opérez-vous ?',
  'onboarding.business.fundingInterests': 'Intérêts de financement (sélectionnez tout ce qui s\'applique)',

  // Company Sizes
  'onboarding.business.size.micro': '1-9 employés (Micro)',
  'onboarding.business.size.small': '10-49 employés (Petite)',
  'onboarding.business.size.medium': '50-249 employés (Moyenne)',
  'onboarding.business.size.large': '250+ employés (Grande)',

  // Industries
  'onboarding.business.industry.agriculture': 'Agriculture & Alimentation',
  'onboarding.business.industry.technology': 'Technologie & IT',
  'onboarding.business.industry.manufacturing': 'Industrie',
  'onboarding.business.industry.energy': 'Énergies Renouvelables',
  'onboarding.business.industry.healthcare': 'Santé',
  'onboarding.business.industry.education': 'Éducation',
  'onboarding.business.industry.tourism': 'Tourisme & Hôtellerie',
  'onboarding.business.industry.transportation': 'Transport',
  'onboarding.business.industry.construction': 'Construction',
  'onboarding.business.industry.services': 'Services Professionnels',
  'onboarding.business.industry.retail': 'Commerce & E-commerce',
  'onboarding.business.industry.other': 'Autre',

  // Funding Interests
  'onboarding.business.funding.rd': 'Subventions R&D',
  'onboarding.business.funding.innovation': 'Financement Innovation',
  'onboarding.business.funding.export': 'Soutien à l\'Export',
  'onboarding.business.funding.digital': 'Transformation Digitale',
  'onboarding.business.funding.green': 'Transition Verte',
  'onboarding.business.funding.training': 'Formation & Compétences',
  'onboarding.business.funding.tax': 'Allègements Fiscaux',
  'onboarding.business.funding.loans': 'Prêts à Taux Réduit',

  // Privacy & Consent
  'onboarding.consent.title': 'Confidentialité & Préférences de Communication',
  'onboarding.consent.subtitle': 'Choisissez comment vous souhaitez utiliser subvention360 et rester informé',
  'onboarding.consent.gdpr': 'Politique de Confidentialité & Conditions',
  'onboarding.consent.gdpr.text': 'J\'accepte la {privacy} et les {terms} de subvention360. Vos données seront traitées de manière sécurisée et utilisées uniquement pour fournir nos services.',
  'onboarding.consent.gdpr.short': 'J\'accepte la Politique de Confidentialité et les Conditions d\'Utilisation. Vos données seront traitées de manière sécurisée.',
  'onboarding.consent.security': 'Vos données sont sécurisées et ne seront utilisées que pour améliorer vos recommandations de subventions.',
  'onboarding.consent.gdpr.accept': 'J\'accepte la',
  'onboarding.consent.gdpr.privacy': 'Politique de Confidentialité',
  'onboarding.consent.gdpr.terms': 'Conditions d\'Utilisation',
  'onboarding.consent.gdpr.and': 'et les',
  'onboarding.consent.gdpr.cgv': 'Conditions Générales de Vente',
  'onboarding.consent.gdpr.dataInfo': 'Vos données seront traitées de manière sécurisée et utilisées uniquement pour fournir nos services.',
  'onboarding.consent.preferences.title': 'Préférences de Communication',
  'onboarding.consent.updates': 'Mises à jour de la plateforme',
  'onboarding.consent.updates.desc': 'Recevoir des informations sur les nouvelles fonctionnalités, améliorations et annonces importantes',
  'onboarding.consent.alerts': 'Alertes d\'aides (Recommandé)',
  'onboarding.consent.alerts.desc': 'Être notifié des nouvelles aides qui correspondent à votre profil et à vos intérêts',
  'onboarding.consent.tips': 'Conseils & Bonnes Pratiques',
  'onboarding.consent.tips.desc': 'Recevoir des conseils utiles pour améliorer vos candidatures et votre taux de succès',
  'onboarding.consent.footer': 'Vous pouvez modifier ces préférences à tout moment dans vos paramètres de compte. Nous respectons votre vie privée et ne partagerons jamais vos données avec des tiers.',

  // Navigation
  'onboarding.wizard.previous': 'Précédent',
  'onboarding.wizard.next': 'Suivant',
  'onboarding.wizard.finish': 'Terminer',
  'onboarding.wizard.configuring': 'Configuration...',
  'onboarding.wizard.progress': 'Étape {current} sur {total} • Presque terminé !',

  // Errors
  'onboarding.error.required': 'Champs requis',
  'onboarding.error.required.desc': 'Veuillez remplir tous les champs obligatoires (*)',
  'onboarding.error.siret.invalid': 'SIRET invalide',
  'onboarding.error.siret.invalid.desc': 'Le numéro SIRET doit contenir exactement 14 chiffres.',
  'onboarding.error.consent.required': 'Acceptation requise',
  'onboarding.error.consent.required.desc': 'Vous devez accepter la Politique de Confidentialité et les Conditions d\'Utilisation pour continuer.',
} as const;
